<template>
<body id="page-top" class="body-bg">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio certificate-login-section" id="portfolio">
            <div class="container">
              <form @submit.prevent="handleSubmit">
                <div class="login-form">
                <p class="h4" style="text-align:center;">What type of assistance would you need from our Customer Experience Advocate?</p>
                <div class="mb-3 row">
                     <b-form-group class="phil-checkbox" v-slot="{ ariaDescribedby }" required>
                        <b-form-checkbox-group
                          v-model="selected"
                          :options="options"
                          :aria-describedby="ariaDescribedby"
                          plain
                          stacked
                        ></b-form-checkbox-group>
                      </b-form-group>
               </div>
        </div>

               <div class="col-md-12">
                  <a style="float:left" type="button" class="btn btn-primary btn-lg"><router-link to="/member-page">CANCEL</router-link></a>
                  <a type="button" class="btn btn-primary btn-lg">PREVIOUS</a>
                  <button class="btn btn-primary btn-lg">NEXT</button>
            </div>
            </form>
             </div> 

             

        </section>
</body>
</template>

<script>
import axios from 'axios';
export default {
  name: 'PhilLogin',
  data() {
    return {
      firstName: '',
      middleName: '',
      lastName: '',
      selected: [], // Must be an array reference!
        options: [
          { text: 'Availment Benefit or Coverage Concern', value: 'Availment Benefit or Coverage Concern' },
          { text: 'Clarification about Letter of Authorization (LOA)', value: 'Clarification about Letter of Authorization (LOA)' },
          { text: 'Cancellation of Unused Letter of Authorization (LOA)', value: 'Cancellation of Unused Letter of Authorization (LOA)' },
          { text: 'Hospital or Doctor Concern', value: 'Hospital or Doctor Concern' },
          { text: 'Others', value: 'Others' }
        ]
    }
  },
  methods: {
    async handleSubmit() {
        const response = await axios.post('/api/?action=customer-support', {
           firstName: this.firstName,
           lastName: this.lastName,
           options: this.options,
           selected: this.selected
        }, 
        );

        console.log(response);
        localStorage.setItem('TokenID', response.data.TokenID)
        this.$router.push('/customer-advocate-2');
    }
  },
  created() {
    if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
